module.exports = __webpack_public_path__ + "img/744.003b2e04.jpg";